import type { CartItem } from "@/features/cart/components/CartItem";
import type { ProductCard, ProductDetails } from "@/lib/centra";
import type { PreoderProduct } from "@kaos/graphql/queries";

export const isProductBundle = (
	product: ProductDetails | ProductCard | CartItem,
): boolean => {
	if ("line" in product && "quantity" in product) {
		const selectionItem = product as CartItem;
		return selectionItem?.product
			? (selectionItem.product.name?.toLowerCase().includes("bundle") ?? false) ||
					(selectionItem.product.uri?.toLowerCase().includes("bundle") ?? false)
			: false;
	}

	const regularProduct = product as ProductDetails | ProductCard;
	return (
		regularProduct.canonicalCategoryUri === "bundles" ||
		regularProduct.canonicalUri?.includes("bundles") ||
		regularProduct.name.toLowerCase().includes("bundle") ||
		regularProduct.uri.toLowerCase().includes("bundle")
	);
};

export const checkProductPreorder = ({
	centraVariantId,
	stock,
	country,
	preorderData,
	language,
}: {
	centraVariantId: number;
	stock: number;
	country: string;
	preorderData: PreoderProduct[];
	language: string;
}): { eta: string } | false => {
	if (stock > 0) {
		return false;
	}

	const preorder = preorderData.find((p) => p.variantId === centraVariantId);

	if (!preorder) {
		return false;
	}

	const warehouseMatch = preorder.warehouses.find((warehouse) =>
		warehouse.countryCodes.includes(country),
	);

	if (!warehouseMatch) {
		return false;
	}

	const eta = new Date(warehouseMatch.eta);
	const today = new Date();

	if (eta.getTime() < today.getTime()) {
		return false;
	}

	return { eta: eta.toLocaleDateString(language) };
};
